import mobileAdjustment from "../GeneralMobileAdjustments";

class  MobileLinkControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        mobileAdjustment.setTextsHeight(element);
        element.find('a:first').css({"font-size": `${control.model.get('fontSize')}px`, "text-align": "left"});
    }

}

const mobileLinkControlView = new MobileLinkControlView();
export default  mobileLinkControlView;